import React from "react";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";

const MaterialButton = (props) => {
  const classes = useStyles();
  const handleClick = () => {
    props.handleClick();
  };
  return (
    <Button
      variant="contained"
      className={classes.button}
      color="primary"
      size="large"
      onClick={handleClick}
      disabled={props.disabled}
      //   fullWidth={true}
    >
      {props.text}
    </Button>
  );
};
const useStyles = makeStyles((theme) => ({
  button: {
    margin: theme.spacing(1),
  },
  input: {
    display: "none",
  },
}));

export default MaterialButton;
